import { render, staticRenderFns } from "./CouponAdd.vue?vue&type=template&id=6e0e939c&scoped=true&"
import script from "./CouponAdd.vue?vue&type=script&lang=js&"
export * from "./CouponAdd.vue?vue&type=script&lang=js&"
import style0 from "./CouponAdd.vue?vue&type=style&index=0&id=6e0e939c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0e939c",
  null
  
)

export default component.exports